import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@core/services/loader.service';
import { RegistrationPresorteoService } from '../../services/registrationPresorteo/registration-presorteo.service';
import { ReportsService } from '../../services/reports.service';

@Component({
  selector: 'app-generate-selection',
  templateUrl: './generate-selection.component.html',
  styleUrls: ['./generate-selection.component.scss']
})
export class GenerateSelectionComponent implements OnInit {

  private formG: FormGroup;
  constructor(
    private fb: FormBuilder,
    private loadService: LoaderService,
    private reportsService: ReportsService,
    private registrationService: RegistrationPresorteoService
  ) { }

  get form(): FormGroup {
    if (!this.formG) {
      this.formG = this.fb.group({
        dateGameLottery: ['', [Validators.required]],
        codeLottery: ['', [Validators.required]]
      });
    }
    return this.formG;
  }

  get formRaw(): {
    codeLottery: string;
    dateGameLottery: Date;
  } {
    return this.formG.getRawValue();
  }

  get valid(): boolean {
    return this.formG.valid;
  }

  ngOnInit(): void {
  }

  generateSelec(): void {
    let request: {
      codeLottery: string;
      dateGameLottery: string;
    };
    request = {
      codeLottery: this.formRaw.codeLottery,
      dateGameLottery: this.formatDate(this.formRaw.dateGameLottery)
    };
    this.loadService.show();
    this.registrationService.createRegistration(request)
    .then(response => {
      if (response.success) {
        this.printReport(response.data.id);
      }
    })
    .finally(() => {
      this.loadService.hide();
    });
  }

  printReport(id: number) {
    let filename = "report-"+Date.now()+".docx";    
    this.reportsService.printReport(id).then(
        (response: HttpResponse<Blob>) => {
            let binaryData = [];
            binaryData.push(response.body);
            let downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
            downloadLink.setAttribute('download', filename);
            document.body.appendChild(downloadLink);
            downloadLink.click();
        }
    );
}

  formatDate = (date: Date): string => {
    let formattedDate = '';
    formattedDate += date.getFullYear();
    formattedDate += '-' + ((date.getMonth() + 1 < 10) ? '0' : '') + (date.getMonth() + 1);
    formattedDate += ((date.getDate() < 10) ? '-0' : '-') + date.getDate();
    formattedDate += ' ' + ((date.getHours() < 10) ? '0' : '') + date.getHours();
    formattedDate += ((date.getMinutes() < 10) ? ':0' : ':') + date.getMinutes();
    formattedDate += ((date.getSeconds() < 10) ? ':0' : ':') + date.getSeconds();
    return formattedDate;
}

}
